import { render, staticRenderFns } from "./IspPositive.vue?vue&type=template&id=874fc502&scoped=true&"
import script from "./IspPositive.vue?vue&type=script&lang=js&"
export * from "./IspPositive.vue?vue&type=script&lang=js&"
import style0 from "./IspPositive.vue?vue&type=style&index=0&id=874fc502&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874fc502",
  null
  
)

export default component.exports